import React, { useEffect } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
// import "../../src/assets/css/bootstrap.min.css";
import "../../src/assets/css/fontawesome-all.min.css";
// import "../../src/assets/css/slick.css";
// import "../../src/assets/css/line-awesome.min.css";
// import "../../src/assets/css/main.css";

import "../../src/assets/stylesheet/bootstrap.min.css";
import "../../src/assets/stylesheet/all-fontawesome.min.css";
import "../../src/assets/stylesheet/animate.min.css";
import "../../src/assets/stylesheet/magnific-popup.min.css";
import "../../src/assets/stylesheet/owl.carousel.min.css";
import "../../src/assets/stylesheet/style.css";

import LogoImage from "../../src/assets/img/logo/logo.png";


// import LogoImage from "../../src/assets/images/all/scan-svgrepo-com 1.svg";



const isActive = (path) => location.pathname === path;

const isHomePage = location.pathname === "/";

const Header = () => {
    const state = useSelector((state) => state.handleCart);
    const navigate = useNavigate();
    const location = useLocation();


    useEffect(() => {
      console.log("Header refreshed on route change:", location.pathname);
      // Add logic here if needed, such as fetching data or resetting state
    }, [location]);
  

  // Navigate to login
  const handleLoginNavigate = () => {
    navigate("/login"); // Navigate to login screen
  };

  // Log out and refresh page
  const handleLogOutNavigate = () => {
    localStorage.removeItem("ACCESS_TOKEN_NAME"); // Remove token
    navigate("/logOut"); // Navigate to logout route
    window.location.reload(); // Refresh the page
  };

  // Navigate to QR Reader
  const handleNavigateToQRReader = () => {
    navigate("/qrReader"); // Navigate to QR Reader screen
  };

  
  return (
    <>
    {/* Preloader */}
    {/* <div class="preloader">
        <div class="loader-book">
            <div class="loader-book-page"></div>
            <div class="loader-book-page"></div>
            <div class="loader-book-page"></div>
        </div>
    </div> */}
    <header class="header">
        
        <div class="header-top">
            <div class="container">
                <div class="header-top-wrap">
                    
                    <div class="header-top-right">
                        <div class="header-top-contact">
                            <ul>
                                
                                <li>
                                    <a href="#"><i class="far fa-envelopes"></i> info@padhaidekho.com</a>
                                </li>
                                <li>
                                    <a href="tel:1800-572-9877"><i class="far fa-phone-volume"></i>1800-572-9877 </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="header-top-left">
                        <div class="header-top-social">
                            <span>Follow Us: </span>
                            <a href="#"><i class="fab fa-facebook-f"></i></a>
                            <a href="#"><i class="fab fa-instagram"></i></a>
                            <a href="#"><i class="fab fa-youtube"></i></a>
                            <a href="#"><i class="fab fa-whatsapp"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="main-navigation">
            <nav class="navbar navbar-expand-lg">
                <div class="container position-relative">
                    <a class="navbar-brand" href="/">
                        <img src={LogoImage} alt="logo" />
                    </a>
                    <div class="mobile-menu-right">
                        
                        <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                            data-bs-target="#main_nav" aria-expanded="false" aria-label="Toggle navigation">
                            <span class="navbar-toggler-mobile-icon"><i class="far fa-bars"></i></span>
                        </button>
                    </div>
                    <div class="collapse navbar-collapse" id="main_nav">
                        <ul class="navbar-nav">
                            <li class="nav-item dropdown">
                                <a class="nav-link active" href="/">Home</a>
                            </li>
                            <li class="nav-item dropdown">
                                <a class="nav-link" href="/Feed">Feeds </a>
                            </li>
                            <li class="nav-item mega-menu dropdown">
                                <a class="nav-link" href="/collage">Colleges</a>  
                            </li>
                             <li class="nav-item mega-menu dropdown">
                                <a class="nav-link" href="/institute">Institutions</a>  
                            </li>
                            <li class="nav-item mega-menu dropdown">
                                <a class="nav-link" href="/course">Courses</a>  
                            </li>
                            <li class="nav-item mega-menu dropdown">
                                <a class="nav-link" href="/teacher">Teachers</a>  
                            </li>
                            <li class="nav-item mega-menu dropdown">
                                <a class="nav-link" href="https://exam.padhaidekho.com/register" target="_blank">Exams</a>  
                            </li>
                            <li class="nav-item mega-menu dropdown">
                                <a class="nav-link" href="/Studyabroad">Study Abroad </a>  
                            </li>
                            <li class="nav-item mega-menu dropdown mobile_list">
                                {localStorage.getItem("ACCESS_TOKEN_NAME") ? (
                                <a onClick={handleLogOutNavigate} >
                                    <span class="tooltip_bx mobile_view">Logout</span>
                                </a>
                                ) : (
                                    <a onClick={handleLoginNavigate}>
                                        <span class="tooltip_bx mobile_view">Login</span>
                                    </a>
                                )}
                            </li>
                            <li class="nav-item mega-menu dropdown mobile_list">
                                <a href="/qrReader" class="scan-me">
                                    <span class="tooltip_bx mobile_view">Scan Me</span>
                                </a>
                            </li>
                        </ul>
                        
                        <div class="nav-right">
                            <div class="nav-right-btn mt-2">
                            {localStorage.getItem("ACCESS_TOKEN_NAME") ? (
                                <a onClick={handleLogOutNavigate} >
                                <i class="fa-regular fa-arrow-right-to-bracket pe-5 position-relative"></i>
                                <span class="tooltip_bx">Logout</span>
                            </a>
                            ) : (
                                <a onClick={handleLoginNavigate}>
                                    <i class="fa-regular fa-arrow-right-to-bracket pe-5 position-relative"></i>
                                    <span class="tooltip_bx">Login</span>
                                </a>
                            )}
                                <a href="/qrReader" class="scan-me"> <i class="fa-regular fa-face-viewfinder position-relative"></i>
                                    <span class="tooltip_bx">Scan Me</span>
                                </a>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </nav>
        </div>
    </header>
      {/* Mobile Menu */}
      

      {/* Header */}
      
    </>
  );
};

export default Header;



